import React from "react";
import AdminAddCopon from "../../Components/Admin/AdminAddCopon";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddCouponPage = ()=>{
    return (
        <div className="d-flex justify-content-start">
        <div>
          <SideBar />
        </div>
        <div className="p-4" style={{ width: '100%' }}>
          <AdminAddCopon />
        </div>
      </div>
    )
}

export default AdminAddCouponPage